import React from 'react';

import { PlusSquareOutlined } from '@ant-design/icons';

const NotificationCardModuleCreateIcon = () => {
  return <PlusSquareOutlined className="text-xl text-yellow-500" />;
};

export default NotificationCardModuleCreateIcon;
